import React from "react";

/**
 * Founder OS brand mark — reproduced from the provided logo.
 * A rounded-square tile with a violet→indigo gradient and a
 * white "sun / orbit" dotted-circle glyph inside.
 */
export const FounderOSMark = ({ size = 40, className = "", withGlow = false }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className={className}
    role="img"
    aria-label="Founder OS"
  >
    <defs>
      <linearGradient id="fos-mark-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#4242FF" />
        <stop offset="55%" stopColor="#7C3AED" />
        <stop offset="100%" stopColor="#A855F7" />
      </linearGradient>
      {withGlow && (
        <filter id="fos-mark-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      )}
    </defs>
    <rect x="1" y="1" width="62" height="62" rx="14" fill="url(#fos-mark-grad)" />
    <g fill="white" filter={withGlow ? "url(#fos-mark-glow)" : undefined}>
      {/* Dotted circle with varying dot sizes — 14 dots around a 20px-radius circle */}
      {Array.from({ length: 14 }).map((_, i) => {
        const angle = (i / 14) * Math.PI * 2 - Math.PI / 2;
        const cx = 32 + Math.cos(angle) * 19;
        const cy = 32 + Math.sin(angle) * 19;
        // Bigger dots on left, tapering to right (matches original)
        const t = (i / 14);
        const r = 3.6 - 2.2 * t;
        return <circle key={i} cx={cx} cy={cy} r={Math.max(r, 1.4)} />;
      })}
    </g>
  </svg>
);

export const FounderOSWordmark = ({ className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <FounderOSMark size={30} />
    <span className="font-display text-white text-xl tracking-[-0.02em] font-semibold" style={{ fontVariationSettings: "'opsz' 24" }}>
      Founder<span className="text-white/60 font-normal ml-1">OS</span>
    </span>
  </div>
);

export default FounderOSMark;
